import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Place} from '../../../models/place';
import {NgIf} from '@angular/common';
import {AuthService} from '../../../services/auth.service';
import {User} from '../../../models/user';
import {PlaceService} from '../../../services/place.service';
import {Subject, takeUntil} from 'rxjs';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-place-box',
  imports: [
    NgIf,
    RouterLink
  ],
  templateUrl: './place-box.component.html',
  styleUrl: './place-box.component.scss'
})
export class PlaceBoxComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<boolean>();

  @Input() place!: Place
  @Input() showLikeButton = true;
  @Input() reservableSeats: number | null = null

  currentUser: User | null = null;

  constructor(private authService: AuthService,
              private placeService: PlaceService) {
  }

  ngOnInit() {
    this.authService.currentUser$.pipe(takeUntil(this.onDestroy$)).subscribe(currentUser => {
      if (currentUser) this.currentUser = currentUser;
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  toggleLike() {
    if (!this.currentUser) {
      return;
    }

    if (!this.place) {
      return;
    }

    const isLike = (this.place.likes!.indexOf(this.currentUser._id!) >= 0);
    if (isLike) {
      this.place.likes!.splice(this.place.likes!.indexOf(this.currentUser._id!), 1);
      this.placeService.unlike(this.place._id!).pipe(takeUntil(this.onDestroy$)).subscribe();
    } else {
      this.place.likes!.push(this.currentUser._id!);
      this.placeService.like(this.place._id!).pipe(takeUntil(this.onDestroy$)).subscribe();
    }
  }

}
